import { render, staticRenderFns } from "./UpdateTrainer.vue?vue&type=template&id=8be26c44&scoped=true"
import script from "./UpdateTrainer.vue?vue&type=script&lang=js"
export * from "./UpdateTrainer.vue?vue&type=script&lang=js"
import style0 from "./UpdateTrainer.vue?vue&type=style&index=0&id=8be26c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be26c44",
  null
  
)

export default component.exports